<script>
    import {
        NormalCell,
    } from 'southcn-mobile-ui';

    export default {
        name: 'NormalQuestionItem',
        props: {
            item: {
                default () {
                    return {};
                },
                required: false
            }
        },
        components: {
            NormalCell,
        }
    };
</script>
<template>
    <div class="qa-item" :class="item.type">
        <normal-cell class="title">
            <template v-slot:header v-if="item.no || item.rules.required">
                <div :class="{required: item.rules.required}">
                    {{item.no ? `${item.no}.` : ''}}
                </div>
            </template>
            <template v-slot:default>
                <div v-html="item.title"></div>
            </template>
        </normal-cell>
        <normal-cell class="hint">
            <template v-slot:default >
                <div v-html="item.hint"></div>
            </template>
        </normal-cell>
        <div class="">
            <slot></slot>
        </div>
        <p class="error-text" v-show="item.errorText">{{item.errorText}}</p>
    </div>
</template>
<style lang="less">
    @import "../../../southcn-mobile-ui/src/assets/less/widgets-var";
    .qa-item {
        .px2rem(margin-bottom, 86);
        > .error-text {
            margin-top: 8px;
        }

        img {
            max-width: 100%;
        }

        &.file {
            .file-button {
                .px2rem(margin-bottom, 24);
            }
        }

        .attachment-list {
            .download-link {
                color: @otherNormalTitleClr;
                text-decoration: underline;
            }

            .error {
                color: @dangerActiveBg;
                display: none;
            }

            &.complete {
                .error-text {
                    color: @green500;
                }
            }

            &.error, &.complete {
                .progress {
                    display: none;
                }

                .error {
                    display: block;
                }
            }

            .normal-cell {
                font-family: cmsicon;
                color: @otherNormalTitleClr;
                .px2rem(line-height, 64);

                &__bd {
                    word-break: break-all;
                    a{
                        overflow: hidden;
                        text-overflow: ellipsis;
                        white-space: nowrap;
                    }
                }

                &__ft {
                    margin-left: 8px;
                }
            }
        }

        &.description {
            .normal-cell {
                &.title {
                    .px2rem(font-size, 28);
                }

                &__hd {
                    display: none;
                }
            }
        }
    }
</style>
<style scoped lang="less">
    @import "../../../southcn-mobile-ui/src/assets/less/widgets-var";
    .normal-cell {
        padding: 0;
        align-items: flex-start;
        .px2rem(font-size, 28);
        color: @otherNormalTitleClr;

        &.title {
            .px2rem(font-size, 32);
        }

        &.hint {
            .px2rem(font-size, 26);
            .px2rem(margin-top, 15);
            .px2rem(margin-bottom, 28);
            color: @otherBtnBorderNoteClr;

        }

        &.option {
            .px2rem(padding-top, 26);
            .px2rem(padding-bottom, 26);
            .px2rem(padding-left, 25);
            .px2rem(padding-right, 25);
            border: 1px solid @otherGreyBgClr;
            border-bottom: none;

            &:first-child {
                border-top-right-radius: 5px;
                border-top-left-radius: 5px;
            }

            &:last-child {
                border-bottom: 1px solid @otherGreyBgClr;
                border-bottom-right-radius: 5px;
                border-bottom-left-radius: 5px;
            }

        }

        .required {
            &:before {
                content: '*';
                font-weight: 700;
                color: @dangerActiveBg;
                margin-right: 5px;
            }
        }
    }
</style>
